<template>
  <div class="updated-date-label">
    <vs-tooltip :text="createdText" color="#2D9CDB">
      {{ updatedText }}
    </vs-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    updatedAt: {
      type: String,
      required: true,
    },
    createdAt: {
      type: String,
      required: true,
    }
  },

  computed: {
    updatedText() {
      return `更新日時：${ this.updatedAt }`
    },
    createdText() {
      return `作成日時：${ this.createdAt }`
    },

  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.vs-tooltip {
  font-family: $aisea-font-family;
}

.updated-date-label {
  font-size: 12px;
}
</style>